import React from 'react';

import { observer } from 'mobx-react';

import { YesNoBtnRow } from '@infoods/lifebase-ui';

import classes from './NgzCoachInfoTab.module.scss';
import { angularizeWithProviders } from '../../../shared/providers';
import { CoachInfoForm } from './CoachInfoForm/CoachInfoForm';
import { CoachBio, CoachData, CoachInfoFormValue } from '../../interfaces/CoachData';
import { PAYMENT_FLOW_TYPE } from '../../../shared/constants/user-info/paymentFlowType';
import { getFlagsObject } from '../../../shared/utils/sortingAndGroupingUtil';
import { CoachStatusToggle } from './CoachStatusToggle/CoachStatusToggle';
import { loggedInUserDataStore } from '../../../shared/stores/loggedInUserDataStore';
import { SolutionTypeFlags } from '../../../shared/constants/user-info/solutionType';

type NgzCoachInfoTabProps = {
  coachInfo: CoachData;
  solutionTypeFlags: SolutionTypeFlags;
  onCoachUpdate: ({ data }: { data: CoachInfoFormValue }) => void;
  onActivationChange: () => void;
  onUpdateCoachBio: ({ bio }: { bio: CoachBio }) => void;
};

const CoachInfoFormId = 'coach-info-form';

const NgzCoachInfoTab = observer(
  ({
    coachInfo,
    solutionTypeFlags,
    onCoachUpdate,
    onActivationChange,
    onUpdateCoachBio,
  }: NgzCoachInfoTabProps) => {
    const { isCoach } = loggedInUserDataStore;

    if (!coachInfo.id) {
      return null;
    }

    const paymentFlowType = getFlagsObject(PAYMENT_FLOW_TYPE, [
      coachInfo.entity.paymentFlowType,
    ]);

    return (
      <>
        <CoachInfoForm
          formId={CoachInfoFormId}
          coachInfo={coachInfo}
          paymentFlowType={paymentFlowType}
          solutionTypeFlags={solutionTypeFlags}
          onSubmit={(data) => onCoachUpdate({ data })}
          onUpdateCoachBio={(data) => onUpdateCoachBio({ bio: data })}
        />
        {!isCoach && (
          <CoachStatusToggle
            active={coachInfo.active}
            coachName={`${coachInfo.firstName} ${coachInfo.lastName}`}
            onActivationChange={onActivationChange}
            entityId={coachInfo.gymId}
            paymentFlowType={paymentFlowType}
          />
        )}
        <YesNoBtnRow
          formId={CoachInfoFormId}
          className={classes.submitButton}
          yesText="Save"
        />
      </>
    );
  },
);

export { NgzCoachInfoTab };

angularizeWithProviders(NgzCoachInfoTab, 'ngzCoachInfoTab', {
  coachInfo: '<',
  solutionTypeFlags: '<',
  onCoachUpdate: '&',
  onActivationChange: '&',
  onUpdateCoachBio: '&',
});
